import { FaqItemFields } from '../FaqItem/query';

export const FaqBlockFields = `
{
    title
    items ${FaqItemFields}
}
`;
